import(/* webpackMode: "eager" */ "/vercel/path0/volya-frontend/app/global-error.tsx");
